export const actions = {
    setData({ state }, data) {
        state.data = data;
    },
    open({ state }) {
        state.active = true;
    },
    reset({ state }) {
        state.active = false;
        state.data = null;
        state.title = null;
    },
    toggle({ state }) {
        state.active = !state.active;
    },
    close({ state }) {
        state.active = false;
    },
};
